<template>
  <div class="modal fade" id="customer_block_reasons_popup" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="updateBlockReasonsFlag = false"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">Customer Block Reasons</h4>
        </div>
        <div class="modal-body row">
          <div class="form-group">
            <div class="row">
              <label class="col-md-8 label_">
                Block Reasons
                <b v-if="blockReasons === null || blockReasons === ''" class="text-danger text-sm"
                >
                  (reasons should not be empty)
                </b>
              </label>
              <div class='pull-right'>
                <a v-if="(!updateBlockReasonsFlag)"
                   v-on:click="updateBlockReasonsFlag = true"
                ><i title='Update' class='fa fa-pencil fa-lg'/>
                </a> &nbsp;
                <a v-if="updateBlockReasonsFlag && isCustomerBlock"
                   data-dismiss="modal"
                   v-on:click="updateBlockReasonsFlag = false"
                ><i title="Close" class="fa fa-trash-o fa-lg"/>
                </a> &nbsp;
                <a v-if="updateBlockReasonsFlag && isCustomerBlock"
                   v-on:click="saveCustomerBlockReasons(false, true)"
                ><i title="Save" class="fa fa-save fa-lg"/>
                </a> &nbsp;

              </div>
            </div>
            <textarea rows="5"
                      class="form-control"
                      placeholder="Enter Customer Block Reasons"
                      v-model="blockReasons"
                      required="required"
                      :disabled="!updateBlockReasonsFlag && customerDetails.blockReasons !== null"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  v-on:click="updateBlockReasonsFlag=false"
          >Close
          </button>
          <button
              type="button"
              class="btn btn-primary"
              :disabled="blockReasons === null || blockReasons === ''"
              @click="saveCustomerBlockReasons(true, (customerDetails.blockReasons === null))"
          >{{(customerDetails.customerStatus === 'active') ? 'Block' : 'Un-Block'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {toggleCustomerStatus} from "../../api/customers";
export default {
  name: "CustomerBlockReasons",
  data(){
    return {
      customerDetails: {},
      isCustomerBlock: false,
      customerBlockReasons: "",
      disable: true,
      updateBlockReasonsFlag: false,
      blockReasons: "",
    }
  },
  methods: {
    load: function (customer){
      this.customerDetails = customer;
      this.disable = true;
      this.isCustomerBlock = (customer.customerStatus === "block");
      this.blockReasons = (this.isCustomerBlock) ? this.customerDetails.blockReasons : null;
      this.updateBlockReasonsFlag = (this.blockReasons === null);
      $("#customer_block_reasons_popup").modal("show");
    },
    saveCustomerBlockReasons: async function (UpdateCustomerStatus, UpdateCustomerBlockReasons) {
      let params = new URLSearchParams();
      let status = this.customerDetails.customerStatus;
      if(UpdateCustomerStatus) {
        status = (status === 'block') ? 'active' : 'block';
      }
      params.append("customer_id", this.customerDetails.id);
      params.append("block_reason", this.blockReasons);
      params.append("customer_status", status);
      let res = null;
      try {
        res = await toggleCustomerStatus(params);
      } catch (e) {
        this.showErrorMessage(e)
      }
      if (res.status === 200) {
        swal("SUCCESS!", "Updated successfully!", "success");
        $("#customer_block_reasons_popup").modal("hide");
        this.updateBlockReasonsFlag = false;
      }
      await this.$parent.dtTable.ajax.reload(null, false);
      this.blockReasons = this.customerDetails.blockReasons;
    },
  }
}
</script>

<style scoped>
.label_{
  padding-right: 0;
}
.pull-right{
  padding-right: 15px;
}
</style>